import React from 'react';

const jsonToCSV = (jsonData: any) => {
  if (!jsonData[0]) {
    return null;
  }

  const headers = Object.keys(jsonData[0]);

  const rows = jsonData.map((obj: any) =>
    headers.map((header) => obj[header]).join(','),
  );

  return [headers.join(','), ...rows].join('\n');
};

const downloadCSV = (csvData: any, filename = 'data.csv') => {
  const blob = new Blob([csvData], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const DownloadCSVJson: React.FC<{ filename: string; json: any }> = ({
  children,
  filename,
  json,
}) => {
  const csvData = jsonToCSV(json);

  return <div onClick={() => downloadCSV(csvData, filename)}>{children}</div>;
};
